import { render } from "./NotificationsCard.vue?vue&type=template&id=6a813cef&scoped=true"
import script from "./NotificationsCard.vue?vue&type=script&lang=js"
export * from "./NotificationsCard.vue?vue&type=script&lang=js"

import "./NotificationsCard.vue?vue&type=style&index=0&id=6a813cef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a813cef"]])

export default __exports__